import React, { FC } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import MultiLineDiv from "../MultiLineDiv/MultiLineDiv";
import { PlayButton, Button } from "../Buttons";
import { ReactImage } from "../ReactImage";
import Border from "../Border/Border";
import { getContentItemMetadata, getFullUrl, Analytics } from "../../utilities";
import _ from "lodash";
import { PageSection } from "../../types";
import "./Hero.scss";

type HeroProps = {
  component: PageSection;
  category: string;
  position: number;
  enableAbroadBanner: () => void;
};

const Hero: FC<HeroProps & RouteComponentProps> = ({ component, history, category, position, enableAbroadBanner }) => {
  const contentItem = component.collection?.nodes?.[0];

  if(!contentItem) return null ;

  const { slide, firstEpisode } = contentItem;
  const { header, subHeader, description, episodesUrl } = getContentItemMetadata(contentItem, "Hero");
  const image =  slide?.image ||  null;
  const contentItemToPlay = firstEpisode || contentItem;
  const headerLines = category ? 2 : 3;
  const descriptionCharacters = 90;

  // BBCPA-229: report the hero module's viewability.select with group_name = the module name
  // (component.name) and item_name = the linked content, mirroring carousel items. Previously the
  // Play button reported the destination page as group_name and View Episodes reported nothing.
  const moduleName = component.name;
  const itemName = header || contentItem.name;
  const reportHeroSelect = (link?: string) => {
    Analytics.userActionSelectContentFromRail(
      moduleName,
      position,
      link ? getFullUrl(link) : "",
      itemName,
      {
        item_name: itemName,
        group_name: moduleName,
        group_item_count: 1,
        item_position: 1,
        group_position: position
      }
    );
  };


  return (
    <div className="Hero">
      { (category && position === 1) && <div className="Hero__meta-category mobileonly">{category}</div> }
      
      <div className="Hero__meta">
        { (category && category !== "Home" && position === 1) && <div className="Hero__meta-category non-mobileonly">{category}</div> }
        <MultiLineDiv className="Hero__meta-header" maxLines={headerLines}>{header}</MultiLineDiv>
        <MultiLineDiv maxLines={1} className="Hero__meta-subheader">{subHeader}</MultiLineDiv>
        <MultiLineDiv className="Hero__meta-description" maxCharacters={descriptionCharacters}>{description}</MultiLineDiv>
        <div className="Hero__meta-buttons">
          <PlayButton
            contentItem={{channel: contentItem.channel, ...contentItemToPlay}}
            enableAbroadBanner={enableAbroadBanner}
            onAnalyticsSelect={() => reportHeroSelect(getContentItemMetadata(contentItem, "Tile").url)}
          />
          { episodesUrl &&
            <Button text="View Episodes" outlined onClick={() => {
              reportHeroSelect(episodesUrl);
              history.push(episodesUrl);
            } } />
          }
        </div>
      </div>
      <div className="Hero__image">
        <div className="Hero__image-hori-gradient" />
        <ReactImage large src={image && image.url} alt="hero" />
      </div>
      <Border />
    </div>
  )
};

export default withRouter(Hero);
